import Header from '../../components/feature/Header';
import Hero from '../../components/feature/Hero';
import About from '../../components/feature/About';
import Services from '../../components/feature/Services';
import BeforeAfterCases from '../../components/feature/BeforeAfterCases';
import TechnicalAndSocial from '../../components/feature/TechnicalAndSocial';
import Testimonials from '../../components/feature/Testimonials';
import Contact from '../../components/feature/Contact';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <BeforeAfterCases />
        <TechnicalAndSocial />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
